import { LocalizedForm } from "common/localization";

export default class LoadioContentProfileEditForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "name",
                    label: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_EDIT.FIELDS.NAME_LABEL",
                    placeholder: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_EDIT.FIELDS.NAME_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "timeStamp",
                    label: "",
                    type: "hidden",
                    value: null,
                },
            ],
        };
    }
}
